import script from "./closebtn.vue?vue&type=script&setup=true&lang=js"
export * from "./closebtn.vue?vue&type=script&setup=true&lang=js"

import "./closebtn.vue?vue&type=style&index=0&id=60fbd1c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fbd1c4"]])

export default __exports__